import { ComponentWithChildren } from 'modules/common/types';
import { createContext, useContext } from 'react';

import { ContextType } from './type';
import { useProviderValue } from './value';

const AppointmentsHighlightContext = createContext<ContextType | null>(null);

const AppointmentsHighlightProvider: ComponentWithChildren = ({ children }) => {
  const providerValue = useProviderValue();

  return (
    <AppointmentsHighlightContext.Provider value={providerValue}>
      {children}
    </AppointmentsHighlightContext.Provider>
  );
};

export const useAppointmentsHighlightContext = () => {
  const context = useContext(AppointmentsHighlightContext);
  if (context === undefined) {
    throw new Error(
      'the useAppointmentsHighlightContext should be used within AppointmentsHighlightProvider!'
    );
  }

  return context;
};

export default AppointmentsHighlightProvider;
